'use client'
import type ProgressBar from '@badrap/bar-of-progress'
import { createContext } from 'react'

interface PageProgressContextInterface {
  progressBar: ProgressBar
}

export const PageProgressContext = createContext<PageProgressContextInterface>({} as PageProgressContextInterface)
